import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Sidebar from './Component/Comman/Sidebar';
import MainIndex from './Screen/MainIndex';
import { Switch, useNavigate, withRouter } from 'react-router-dom';
import AuthIndex from './Screen/AuthIndex';
import ProtectedRoute from './Component/Comman/ProtectedRoute';
import menu from '../src/Component/Data/Menu/Menu.json';
import menu2 from '../src/Component/Data/Menu/Menu2.json';
import { checkAuth } from './Redux/Actions/authActions';
import { getBaseUrl } from './utils/urlHelper';

function App(props) {
  const { checkAuth, isAuthenticated, loading } = props;
  const [menuData, setMenuData] = useState([...menu.menu]);
  const navigate = useNavigate();
  const baseUrl = getBaseUrl();

  useEffect(() => {
    // Check authentication on mount
    checkAuth();
  }, [checkAuth]);

  const activekey = () => {
    var res = window.location.pathname
    // Normalize PUBLIC_URL - remove /template/cryptoon/react if present
    var normalizedBaseUrl = getBaseUrl() || '/'
    // Remove trailing slash and split
    normalizedBaseUrl = normalizedBaseUrl.replace(/\/$/, '');
    normalizedBaseUrl = normalizedBaseUrl.split("/").filter(Boolean); // Filter out empty strings
    res = res.split("/").filter(Boolean); // Filter out empty strings
    res = res.length > normalizedBaseUrl.length ? "/" + res[normalizedBaseUrl.length] : "/";
    const activeKey1 = res;
    return activeKey1
  }
  
  // Show loading while checking auth
  if (loading && !isAuthenticated) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (activekey() === '/sign-in' || activekey() === '/sign-up' || activekey() === '/forgot-password' || activekey() === '/verification' || activekey() === '/404page') {
    return (
      <div id="cryptoon-layout" className='theme-orange'>
        <AuthIndex />
      </div>
    );
  }
  const GotoChangeMenu = (val) => {
    // Navigate to dashboard and reset menu
      navigate(baseUrl ? baseUrl + '/' : '/')
      setMenuData([...menu.menu]);
  }

  // console.log(activekey())
  return (
    <ProtectedRoute>
      <div id='cryptoon-layout' className='theme-orange'>
        <Sidebar
          activekey={activekey()}
          menuData={menuData}
          GotoChangeMenu={(val) => { GotoChangeMenu(val) }}
        />
        <MainIndex activekey={activekey()}
          GotoChangeMenu={(val) => { GotoChangeMenu(val) }}
        />
      </div>
    </ProtectedRoute>
  );
}
const mapStateToProps = (state) => ({
  Mainreducer: state.Mainreducer,
  isAuthenticated: state.auth?.isAuthenticated || false,
  loading: state.auth?.loading || false,
})

export default connect(mapStateToProps, {
  checkAuth
})(App);
